/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiResult,
    BalenaDeviceDto,
    BalenaReleaseDto,
    ConnectivityStatusDto,
    CoreConfigHistoryDto,
    CoreDeviceStatusDto,
    CreateCoreConfigRequest,
    DistributionBoardSnapshotDto,
    GetCoreConfigResponse,
    LoadReductionDto,
    OccpLogEntry,
    PinReleaseToDeviceRequest,
    StatusItemDto,
} from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    BalenaDeviceDtoFromJSON,
    BalenaDeviceDtoToJSON,
    BalenaReleaseDtoFromJSON,
    BalenaReleaseDtoToJSON,
    ConnectivityStatusDtoFromJSON,
    ConnectivityStatusDtoToJSON,
    CoreConfigHistoryDtoFromJSON,
    CoreConfigHistoryDtoToJSON,
    CoreDeviceStatusDtoFromJSON,
    CoreDeviceStatusDtoToJSON,
    CreateCoreConfigRequestFromJSON,
    CreateCoreConfigRequestToJSON,
    DistributionBoardSnapshotDtoFromJSON,
    DistributionBoardSnapshotDtoToJSON,
    GetCoreConfigResponseFromJSON,
    GetCoreConfigResponseToJSON,
    LoadReductionDtoFromJSON,
    LoadReductionDtoToJSON,
    OccpLogEntryFromJSON,
    OccpLogEntryToJSON,
    PinReleaseToDeviceRequestFromJSON,
    PinReleaseToDeviceRequestToJSON,
    StatusItemDtoFromJSON,
    StatusItemDtoToJSON,
} from "../models/index";

export interface ClearDraftCoreConfigsRequest {
    deviceIdentity: string;
}

export interface CreateCoreConfigOperationRequest {
    deviceIdentity: string;
    body?: CreateCoreConfigRequest;
}

export interface GetBalenaDeviceRequest {
    deviceIdentity: string;
}

export interface GetBalenaReleasesRequest {
    deviceIdentity: string;
}

export interface GetConnectivityStatusesRequest {
    deviceIdentity: string;
    timeRange: GetConnectivityStatusesTimeRangeEnum;
    threshold: number;
}

export interface GetCoreConfigRequest {
    deviceIdentity: string;
    includeDraft?: boolean;
}

export interface GetCoreConfigByIdRequest {
    deviceIdentity: string;
    coreConfigurationId: number;
}

export interface GetCoreConfigHistoryRequest {
    deviceIdentity: string;
}

export interface GetCoreOcppLogsRequest {
    deviceIdentity: string;
}

export interface GetDeviceStatusesRequest {
    deviceIdentity: string;
    timeRange: GetDeviceStatusesTimeRangeEnum;
    threshold: number;
}

export interface GetDistributionBoardSnapshotsRequest {
    deviceIdentity: string;
    distributionBoardUniqueId: string;
    timeRange: GetDistributionBoardSnapshotsTimeRangeEnum;
}

export interface GetLoadReductionStatusesRequest {
    deviceIdentity: string;
    timeRange: GetLoadReductionStatusesTimeRangeEnum;
    threshold: number;
}

export interface GetStatusesRequest {
    deviceIdentity: string;
    timeRange: GetStatusesTimeRangeEnum;
}

export interface HardRebootDeviceRequest {
    deviceIdentity: string;
}

export interface PinReleaseToDeviceOperationRequest {
    deviceIdentity: string;
    body?: PinReleaseToDeviceRequest;
}

export interface SoftRebootDeviceRequest {
    deviceIdentity: string;
}

/**
 *
 */
export class CoreHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Clear all draft CORE configs for the given device identity.
     */
    async clearDraftCoreConfigsRaw(
        requestParameters: ClearDraftCoreConfigsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling clearDraftCoreConfigs().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/config/clear`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Clear all draft CORE configs for the given device identity.
     */
    async clearDraftCoreConfigs(
        requestParameters: ClearDraftCoreConfigsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.clearDraftCoreConfigsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Create the CORE config for the given device identity.
     */
    async createCoreConfigRaw(
        requestParameters: CreateCoreConfigOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling createCoreConfig().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/config`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: CreateCoreConfigRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Create the CORE config for the given device identity.
     */
    async createCoreConfig(
        requestParameters: CreateCoreConfigOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.createCoreConfigRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the Balena device for the given device identity.
     */
    async getBalenaDeviceRaw(
        requestParameters: GetBalenaDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<BalenaDeviceDto>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getBalenaDevice().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/balena`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            BalenaDeviceDtoFromJSON(jsonValue),
        );
    }

    /**
     * Get the Balena device for the given device identity.
     */
    async getBalenaDevice(
        requestParameters: GetBalenaDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<BalenaDeviceDto> {
        const response = await this.getBalenaDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the Balena releases available to the given device identity.
     */
    async getBalenaReleasesRaw(
        requestParameters: GetBalenaReleasesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<BalenaReleaseDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getBalenaReleases().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/balena-releases`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(BalenaReleaseDtoFromJSON),
        );
    }

    /**
     * Get the Balena releases available to the given device identity.
     */
    async getBalenaReleases(
        requestParameters: GetBalenaReleasesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<BalenaReleaseDto>> {
        const response = await this.getBalenaReleasesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the CORE device connectivity statuses for the given device identity.
     */
    async getConnectivityStatusesRaw(
        requestParameters: GetConnectivityStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<ConnectivityStatusDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getConnectivityStatuses().',
            );
        }

        if (requestParameters["timeRange"] == null) {
            throw new runtime.RequiredError(
                "timeRange",
                'Required parameter "timeRange" was null or undefined when calling getConnectivityStatuses().',
            );
        }

        if (requestParameters["threshold"] == null) {
            throw new runtime.RequiredError(
                "threshold",
                'Required parameter "threshold" was null or undefined when calling getConnectivityStatuses().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["timeRange"] != null) {
            queryParameters["timeRange"] = requestParameters["timeRange"];
        }

        if (requestParameters["threshold"] != null) {
            queryParameters["threshold"] = requestParameters["threshold"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/connectivity-statuses`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(ConnectivityStatusDtoFromJSON),
        );
    }

    /**
     * Get the CORE device connectivity statuses for the given device identity.
     */
    async getConnectivityStatuses(
        requestParameters: GetConnectivityStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<ConnectivityStatusDto>> {
        const response = await this.getConnectivityStatusesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the CORE config for the given device identity.
     */
    async getCoreConfigRaw(
        requestParameters: GetCoreConfigRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<GetCoreConfigResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getCoreConfig().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["includeDraft"] != null) {
            queryParameters["includeDraft"] = requestParameters["includeDraft"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/config`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            GetCoreConfigResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get the CORE config for the given device identity.
     */
    async getCoreConfig(
        requestParameters: GetCoreConfigRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<GetCoreConfigResponse> {
        const response = await this.getCoreConfigRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a specific CORE config by ID for the given device identity, including its full blob content.
     */
    async getCoreConfigByIdRaw(
        requestParameters: GetCoreConfigByIdRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<GetCoreConfigResponse>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getCoreConfigById().',
            );
        }

        if (requestParameters["coreConfigurationId"] == null) {
            throw new runtime.RequiredError(
                "coreConfigurationId",
                'Required parameter "coreConfigurationId" was null or undefined when calling getCoreConfigById().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/config/{coreConfigurationId}`
                    .replace(
                        `{${"deviceIdentity"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceIdentity"]),
                        ),
                    )
                    .replace(
                        `{${"coreConfigurationId"}}`,
                        encodeURIComponent(
                            String(requestParameters["coreConfigurationId"]),
                        ),
                    ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            GetCoreConfigResponseFromJSON(jsonValue),
        );
    }

    /**
     * Get a specific CORE config by ID for the given device identity, including its full blob content.
     */
    async getCoreConfigById(
        requestParameters: GetCoreConfigByIdRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<GetCoreConfigResponse> {
        const response = await this.getCoreConfigByIdRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get an OData-queryable changelog of all non-shadow CORE configs for the given device identity, ordered newest first.
     */
    async getCoreConfigHistoryRaw(
        requestParameters: GetCoreConfigHistoryRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<CoreConfigHistoryDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getCoreConfigHistory().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/config/history`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(CoreConfigHistoryDtoFromJSON),
        );
    }

    /**
     * Get an OData-queryable changelog of all non-shadow CORE configs for the given device identity, ordered newest first.
     */
    async getCoreConfigHistory(
        requestParameters: GetCoreConfigHistoryRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<CoreConfigHistoryDto>> {
        const response = await this.getCoreConfigHistoryRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the CORE OCPP logs for the given device identity.
     */
    async getCoreOcppLogsRaw(
        requestParameters: GetCoreOcppLogsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<OccpLogEntry>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getCoreOcppLogs().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/ocpp-logs`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(OccpLogEntryFromJSON),
        );
    }

    /**
     * Get the CORE OCPP logs for the given device identity.
     */
    async getCoreOcppLogs(
        requestParameters: GetCoreOcppLogsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<OccpLogEntry>> {
        const response = await this.getCoreOcppLogsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the CORE device statuses for the given device identity.
     */
    async getDeviceStatusesRaw(
        requestParameters: GetDeviceStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<CoreDeviceStatusDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getDeviceStatuses().',
            );
        }

        if (requestParameters["timeRange"] == null) {
            throw new runtime.RequiredError(
                "timeRange",
                'Required parameter "timeRange" was null or undefined when calling getDeviceStatuses().',
            );
        }

        if (requestParameters["threshold"] == null) {
            throw new runtime.RequiredError(
                "threshold",
                'Required parameter "threshold" was null or undefined when calling getDeviceStatuses().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["timeRange"] != null) {
            queryParameters["timeRange"] = requestParameters["timeRange"];
        }

        if (requestParameters["threshold"] != null) {
            queryParameters["threshold"] = requestParameters["threshold"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/device-statuses`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(CoreDeviceStatusDtoFromJSON),
        );
    }

    /**
     * Get the CORE device statuses for the given device identity.
     */
    async getDeviceStatuses(
        requestParameters: GetDeviceStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<CoreDeviceStatusDto>> {
        const response = await this.getDeviceStatusesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the CORE distribution board snapshots for the given device identity and distribution board unique id.
     */
    async getDistributionBoardSnapshotsRaw(
        requestParameters: GetDistributionBoardSnapshotsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DistributionBoardSnapshotDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getDistributionBoardSnapshots().',
            );
        }

        if (requestParameters["distributionBoardUniqueId"] == null) {
            throw new runtime.RequiredError(
                "distributionBoardUniqueId",
                'Required parameter "distributionBoardUniqueId" was null or undefined when calling getDistributionBoardSnapshots().',
            );
        }

        if (requestParameters["timeRange"] == null) {
            throw new runtime.RequiredError(
                "timeRange",
                'Required parameter "timeRange" was null or undefined when calling getDistributionBoardSnapshots().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["timeRange"] != null) {
            queryParameters["timeRange"] = requestParameters["timeRange"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/snapshots/distribution-board/{distributionBoardUniqueId}`
                    .replace(
                        `{${"deviceIdentity"}}`,
                        encodeURIComponent(
                            String(requestParameters["deviceIdentity"]),
                        ),
                    )
                    .replace(
                        `{${"distributionBoardUniqueId"}}`,
                        encodeURIComponent(
                            String(
                                requestParameters["distributionBoardUniqueId"],
                            ),
                        ),
                    ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DistributionBoardSnapshotDtoFromJSON),
        );
    }

    /**
     * Get the CORE distribution board snapshots for the given device identity and distribution board unique id.
     */
    async getDistributionBoardSnapshots(
        requestParameters: GetDistributionBoardSnapshotsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DistributionBoardSnapshotDto>> {
        const response = await this.getDistributionBoardSnapshotsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the CORE device load reduction statuses for the given device identity.
     */
    async getLoadReductionStatusesRaw(
        requestParameters: GetLoadReductionStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<LoadReductionDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getLoadReductionStatuses().',
            );
        }

        if (requestParameters["timeRange"] == null) {
            throw new runtime.RequiredError(
                "timeRange",
                'Required parameter "timeRange" was null or undefined when calling getLoadReductionStatuses().',
            );
        }

        if (requestParameters["threshold"] == null) {
            throw new runtime.RequiredError(
                "threshold",
                'Required parameter "threshold" was null or undefined when calling getLoadReductionStatuses().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["timeRange"] != null) {
            queryParameters["timeRange"] = requestParameters["timeRange"];
        }

        if (requestParameters["threshold"] != null) {
            queryParameters["threshold"] = requestParameters["threshold"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/load-reduction-statuses`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(LoadReductionDtoFromJSON),
        );
    }

    /**
     * Get the CORE device load reduction statuses for the given device identity.
     */
    async getLoadReductionStatuses(
        requestParameters: GetLoadReductionStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<LoadReductionDto>> {
        const response = await this.getLoadReductionStatusesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the CORE device statuses for the given device identity.
     */
    async getStatusesRaw(
        requestParameters: GetStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<StatusItemDto>>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling getStatuses().',
            );
        }

        if (requestParameters["timeRange"] == null) {
            throw new runtime.RequiredError(
                "timeRange",
                'Required parameter "timeRange" was null or undefined when calling getStatuses().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["timeRange"] != null) {
            queryParameters["timeRange"] = requestParameters["timeRange"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/statuses`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(StatusItemDtoFromJSON),
        );
    }

    /**
     * Get the CORE device statuses for the given device identity.
     */
    async getStatuses(
        requestParameters: GetStatusesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<StatusItemDto>> {
        const response = await this.getStatusesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Hard reboot the device by its device identity.
     */
    async hardRebootDeviceRaw(
        requestParameters: HardRebootDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling hardRebootDevice().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/hard-reboot`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Hard reboot the device by its device identity.
     */
    async hardRebootDevice(
        requestParameters: HardRebootDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.hardRebootDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get the Balena releases available to the given device identity.
     */
    async pinReleaseToDeviceRaw(
        requestParameters: PinReleaseToDeviceOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling pinReleaseToDevice().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/balena-update`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "PATCH",
                headers: headerParameters,
                query: queryParameters,
                body: PinReleaseToDeviceRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Get the Balena releases available to the given device identity.
     */
    async pinReleaseToDevice(
        requestParameters: PinReleaseToDeviceOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.pinReleaseToDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Soft reboot the device by its device identity.
     */
    async softRebootDeviceRaw(
        requestParameters: SoftRebootDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["deviceIdentity"] == null) {
            throw new runtime.RequiredError(
                "deviceIdentity",
                'Required parameter "deviceIdentity" was null or undefined when calling softRebootDevice().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/core/{deviceIdentity}/soft-reboot`.replace(
                    `{${"deviceIdentity"}}`,
                    encodeURIComponent(
                        String(requestParameters["deviceIdentity"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Soft reboot the device by its device identity.
     */
    async softRebootDevice(
        requestParameters: SoftRebootDeviceRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.softRebootDeviceRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}

/**
 * @export
 */
export const GetConnectivityStatusesTimeRangeEnum = {
    Previous24Hours: "previous24Hours",
    Previous7Days: "previous7Days",
    Previous30Days: "previous30Days",
} as const;
export type GetConnectivityStatusesTimeRangeEnum =
    (typeof GetConnectivityStatusesTimeRangeEnum)[keyof typeof GetConnectivityStatusesTimeRangeEnum];
/**
 * @export
 */
export const GetDeviceStatusesTimeRangeEnum = {
    Previous24Hours: "previous24Hours",
    Previous7Days: "previous7Days",
    Previous30Days: "previous30Days",
} as const;
export type GetDeviceStatusesTimeRangeEnum =
    (typeof GetDeviceStatusesTimeRangeEnum)[keyof typeof GetDeviceStatusesTimeRangeEnum];
/**
 * @export
 */
export const GetDistributionBoardSnapshotsTimeRangeEnum = {
    Previous24Hours: "previous24Hours",
    Previous7Days: "previous7Days",
    Previous30Days: "previous30Days",
} as const;
export type GetDistributionBoardSnapshotsTimeRangeEnum =
    (typeof GetDistributionBoardSnapshotsTimeRangeEnum)[keyof typeof GetDistributionBoardSnapshotsTimeRangeEnum];
/**
 * @export
 */
export const GetLoadReductionStatusesTimeRangeEnum = {
    Previous24Hours: "previous24Hours",
    Previous7Days: "previous7Days",
    Previous30Days: "previous30Days",
} as const;
export type GetLoadReductionStatusesTimeRangeEnum =
    (typeof GetLoadReductionStatusesTimeRangeEnum)[keyof typeof GetLoadReductionStatusesTimeRangeEnum];
/**
 * @export
 */
export const GetStatusesTimeRangeEnum = {
    Previous24Hours: "previous24Hours",
    Previous7Days: "previous7Days",
    Previous30Days: "previous30Days",
} as const;
export type GetStatusesTimeRangeEnum =
    (typeof GetStatusesTimeRangeEnum)[keyof typeof GetStatusesTimeRangeEnum];
